import { PoComboFilter, PoComboOption } from "@po-ui/ng-components";
import { EMPTY, Observable, of } from "rxjs";

import { Area } from "src/app/interfaces/area";
import { Tribe } from "src/app/interfaces/tribe";

export interface AreaComboOption extends PoComboOption {
  value: string;
  label: string;
  tribeName: string;
}

export class AreaComboFilter implements PoComboFilter {
  private options: Array<AreaComboOption> = [];

  setData(areas: Array<Area>, tribes: Array<Tribe>): void {
    const tribeName = new Map(tribes.map((t) => [t.id, t.tribe]));
    this.options = areas
      .map((a) => ({
        value: a.id,
        label: a.area,
        tribeName: (a.tribe && tribeName.get(a.tribe)) || "Sem tribe",
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  getFilteredData(params?: { value?: string }): Observable<Array<PoComboOption>> {
    const q = (params?.value ?? "").trim().toLowerCase();
    const matches = q ? this.options.filter((o) => o.label.toLowerCase().includes(q) || o.tribeName.toLowerCase().includes(q)) : this.options;
    return of(matches);
  }

  getObjectByValue(value: string | number): Observable<PoComboOption> {
    const found = this.options.find((o) => o.value === value);
    return found ? of(found) : EMPTY;
  }
}
